import { useMemo, useSyncExternalStore } from 'react';
import {
  getThemeState,
  resolvedThemeOf,
  setThemeContrast,
  setThemePreference,
  subscribeTheme,
} from './themeStore';
import type { ContrastPreference, ResolvedTheme, ThemePreference } from './theme';

export interface ThemeController {
  /** 用户的偏好（可能是 `system`） */
  preference: ThemePreference;
  /** 实际生效的外观 */
  resolved: ResolvedTheme;
  contrast: ContrastPreference;
  setPreference: (preference: ThemePreference) => void;
  setContrast: (contrast: ContrastPreference) => void;
}

/**
 * 读取并修改外观。
 *
 * 状态本身在 `themeStore` 的单例里，所以任何数量的调用方看到的都是同一份值；
 * 这里只负责把它接进 React 的渲染周期。
 */
export function useTheme(): ThemeController {
  const state = useSyncExternalStore(subscribeTheme, getThemeState, getThemeState);

  return useMemo(
    () => ({
      preference: state.preference,
      resolved: resolvedThemeOf(state),
      contrast: state.contrast,
      setPreference: setThemePreference,
      setContrast: setThemeContrast,
    }),
    [state],
  );
}
